import _implicitStylesheets from "./reviewsErrorState.css";
import _implicitScopedStylesheets from "./reviewsErrorState.scoped.css?scoped=true";
import _adsImage from "ads/image";
import _wdsButton from "wds/button";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<p class="no-results error-title${0}"${2}>${"t1"}</p>`;
const $fragment2 = parseFragment`<p data-testid="error-description" class="error-description${0}"${2}>${"t1"}</p>`;
const stc0 = {
  classMap: {
    "error-container": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "error-image": true
  },
  key: 1
};
const stc2 = {
  "data-testid": "try-again-button"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, b: api_bind} = $api;
  const {_m0} = $ctx;
  return [api_element("div", stc0, [api_element("div", stc1, [api_custom_element("ads-image", _adsImage, {
    props: {
      "src": "./images/search/error.svg",
      "width": $cmp.loadingImageWidth,
      "height": $cmp.loadingImageHeight,
      "alt": ""
    },
    key: 2
  })]), api_static_fragment($fragment1, 4, [api_static_part(1, null, api_dynamic_text($cmp.reviewErrorTitle))]), api_static_fragment($fragment2, 6, [api_static_part(1, null, api_dynamic_text($cmp.reviewErrorDescription))]), api_custom_element("wds-button", _wdsButton, {
    attrs: stc2,
    props: {
      "icon": "refresh",
      "label": $cmp.reviewErrorTryAgainBtn
    },
    key: 7,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleReviewsRetry))
    }
  })])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5p4uosd0ueu";
tmpl.legacyStylesheetToken = "undefined-_reviewsErrorState";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
